export default class Mask {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        return '999 99';
    }

    birthdate() {
        return '39-19-2999';
    }
}
